(() => {
  const BIS_SELECTORS = {
    wrappers: 'product-form, .sticky-add-to-cart, .product-add-to-cart-button',
    bisWrapper: '[data-bis-wrapper]',
    bisButton: '.klaviyo-bis-trigger',
    buyButtonBlock: '[data-buy-button-block]',
    stickyAtcWrapper: '.sticky-add-to-cart',
    addToCartButton: '[data-ref="add-to-cart-button"]',
    hiddenVariantInput: 'input[name="id"]',
  };

  const KLAVIYO_DEFAULTS = {
    account: 'SkKghr',
    buttonText: "M'avertir quand le produit est disponible",
    modalBody: "S'inscrire pour recevoir une notification lorsque l'article sera de nouveau en stock.",
    modalEmail: 'Email',
    modalSuccess: 'Tu es bien inscrite !',
    buttonTextColor: '#fff',
    buttonBackgroundColor: '#ff5086',
  };

  const strings = window.klaviyoStrings || {};
  const config = window.klaviyoBackInStockConfig || {};

  const setDisplay = (element, value) => {
    if (element) {
      element.style.display = value;
    }
  };

  const getCurrentVariant = (container, variant) => {
    if (variant) return variant;

    const hiddenVariantInput = container.querySelector(BIS_SELECTORS.hiddenVariantInput);
    const addToCartButton = container.querySelector(BIS_SELECTORS.addToCartButton);

    return {
      id: hiddenVariantInput?.value || '',
      available: addToCartButton ? !addToCartButton.disabled : true,
    };
  };

  const updateBackInStockVisibility = (container, variant = null) => {
    if (!container) return;

    const bisWrapper = container.querySelector(BIS_SELECTORS.bisWrapper);
    if (!bisWrapper) return;

    const bisButton = container.querySelector(BIS_SELECTORS.bisButton);
    const buyButtonBlock = container.querySelector(BIS_SELECTORS.buyButtonBlock);
    const stickyAtcWrapper = container.querySelector(BIS_SELECTORS.stickyAtcWrapper);
    const currentVariant = getCurrentVariant(container, variant);

    if (currentVariant?.available === false) {
      bisWrapper.removeAttribute('data-bis-hidden');
      setDisplay(bisWrapper, 'block');

      if (bisButton) {
        bisButton.setAttribute('data-variant-id', currentVariant.id || '');
      }

      setDisplay(buyButtonBlock, 'none');

      // Hide sticky wrapper only if the BIS button is rendered outside of it.
      if (stickyAtcWrapper && !stickyAtcWrapper.contains(bisWrapper)) {
        setDisplay(stickyAtcWrapper, 'none');
      }

      return;
    }

    bisWrapper.setAttribute('data-bis-hidden', '');
    setDisplay(bisWrapper, 'none');
    setDisplay(buyButtonBlock, 'flex');
    setDisplay(stickyAtcWrapper, 'block');
  };

  const updateAllBackInStockVisibility = () => {
    document.querySelectorAll(BIS_SELECTORS.wrappers).forEach((container) => {
      updateBackInStockVisibility(container);
    });
  };

  const initBackInStock = () => {
    if (window.__klaviyoBackInStockInitialized) {
      return true;
    }

    if (!window.klaviyo || typeof window.klaviyo.init !== 'function') {
      return false;
    }

    window.__klaviyoBackInStockInitialized = true;

    window.klaviyo.init({
      account: config.account || KLAVIYO_DEFAULTS.account,
      platform: 'shopify',
    });

    window.klaviyo.enable('backinstock', {
      trigger: {
        product_page_text: strings.backInStockButton || KLAVIYO_DEFAULTS.buttonText,
        product_page_class: 'klaviyo-bis-trigger',
        product_page_text_align: 'center',
        product_page_margin: '0px',
        replace_anchor: false,
      },
      modal: {
        headline: '{product_name}',
        body_content: strings.backInStockModalBody || KLAVIYO_DEFAULTS.modalBody,
        email_field_label: strings.backInStockModalEmail || KLAVIYO_DEFAULTS.modalEmail,
        button_label: strings.backInStockModalButton || KLAVIYO_DEFAULTS.buttonText,
        subscription_success_label: strings.backInStockModalSuccess || KLAVIYO_DEFAULTS.modalSuccess,
        footer_content: strings.backInStockModalFooter || '',
        additional_styles:
          'body, input, select, textarea, button, .btn, .form-control { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important; } .btn-success, .form-control { border-radius: 30px; } .modal-title, #klaviyo-bis-modal h3 { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important; }',
        drop_background_color: '#000',
        background_color: '#fff',
        text_color: '#222',
        button_text_color: config.buttonTextColor || KLAVIYO_DEFAULTS.buttonTextColor,
        button_background_color: config.buttonBackgroundColor || KLAVIYO_DEFAULTS.buttonBackgroundColor,
        close_button_color: '#ccc',
        error_background_color: '#fcd6d7',
        error_text_color: '#C72E2F',
        success_background_color: '#d3efcd',
        success_text_color: '#1B9500',
      },
    });

    updateAllBackInStockVisibility();
    return true;
  };

  document.addEventListener('DOMContentLoaded', updateAllBackInStockVisibility, { once: true });

  document.addEventListener('variant:updated', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const container = target?.closest('product-form') || document;
    updateBackInStockVisibility(container, event.detail?.resource || null);
  });

  document.addEventListener('form:updated', updateAllBackInStockVisibility);

  if (initBackInStock()) {
    return;
  }

  let attempts = 0;
  const interval = window.setInterval(() => {
    attempts += 1;

    if (initBackInStock() || attempts >= 50) {
      window.clearInterval(interval);
    }
  }, 200);
})();

// Hide "draft" variants in the Klaviyo BIS modal.
(() => {
  const DRAFT_PATTERN = /\b(draft|mvr)\b/i;
  const MODAL_SELECTOR = '#klaviyo-bis-modal';
  const DROPDOWN_SELECTORS = '.dropdown-menu, .selectpicker, .dropdown, .bootstrap-select';
  const MODAL_SELECTORS = 'select, select#variants, .bootstrap-select select';

  const filterDraftOptions = (select) => {
    const options = Array.from(select.options);
    let removedSelected = false;

    options.forEach((option) => {
      if (!DRAFT_PATTERN.test(option.textContent)) return;

      if (option.selected) {
        removedSelected = true;
      }

      option.remove();
    });

    if (!removedSelected || !select.options[0]) return;

    select.options[0].selected = true;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const filterDraftDropdownItems = (container) => {
    container.querySelectorAll("[role='option'], li, a, span").forEach((item) => {
      if (DRAFT_PATTERN.test(item.textContent)) {
        item.remove();
      }
    });
  };

  const observeMutations = (element, callback, options, key) => {
    if (!element || element.dataset[key] === 'true') return;

    element.dataset[key] = 'true';
    const observer = new MutationObserver(callback);
    observer.observe(element, options);
  };

  const handleContainer = (container) => {
    container.querySelectorAll('select').forEach((select) => {
      filterDraftOptions(select);
      observeMutations(
        select,
        () => filterDraftOptions(select),
        { childList: true },
        'draftSelectObserved',
      );
    });

    container.querySelectorAll(DROPDOWN_SELECTORS).forEach((dropdown) => {
      filterDraftDropdownItems(dropdown);
      observeMutations(
        dropdown,
        () => filterDraftDropdownItems(dropdown),
        { childList: true, subtree: true },
        'draftDropdownObserved',
      );
    });
  };

  const observedDocs = new WeakSet();

  const handleGlobalDropdowns = (doc) => {
    doc.querySelectorAll('.bootstrap-select .dropdown-menu, .dropdown-menu[role="listbox"]').forEach((dropdown) => {
      filterDraftDropdownItems(dropdown);
    });
  };

  const handleDocument = (doc) => {
    const modal = doc.querySelector(MODAL_SELECTOR);
    if (!modal) return;

    handleContainer(modal);

    const variantSelectInModal = modal.querySelector('#variant_select');
    if (variantSelectInModal) {
      handleContainer(variantSelectInModal);
    }

    modal.querySelectorAll(MODAL_SELECTORS).forEach((select) => {
      filterDraftOptions(select);
    });

    handleGlobalDropdowns(doc);
  };

  const observeDocument = (doc) => {
    if (!doc?.body || observedDocs.has(doc)) return;

    observedDocs.add(doc);
    const observer = new MutationObserver(() => {
      handleDocument(doc);
    });
    observer.observe(doc.body, { childList: true, subtree: true });
  };

  const openAndFilter = () => {
    handleDocument(document);

    document.querySelectorAll('iframe').forEach((iframe) => {
      try {
        const frameDoc = iframe.contentDocument;
        if (!frameDoc) return;

        handleDocument(frameDoc);
        observeDocument(frameDoc);
      } catch (error) {
        // Cross-origin iframe, cannot access.
      }
    });
  };

  let filterIntervalId = null;
  const startFilterLoop = () => {
    if (filterIntervalId) return;

    filterIntervalId = window.setInterval(() => {
      openAndFilter();

      const hasTargets = document.querySelector(MODAL_SELECTOR) || document.querySelector('#variant_select');
      if (!hasTargets) {
        window.clearInterval(filterIntervalId);
        filterIntervalId = null;
      }
    }, 200);
  };

  const targetMatches = (event, selector) => event.target instanceof Element && event.target.closest(selector);

  const modalObserver = new MutationObserver(() => {
    openAndFilter();
    startFilterLoop();
  });

  modalObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', (event) => {
    const isBisTrigger = targetMatches(event, '.klaviyo-bis-trigger');
    const isVariantSelect = targetMatches(event, '#variant_select, .bootstrap-select');

    if (isBisTrigger || isVariantSelect) {
      startFilterLoop();
    }
  });

  document.addEventListener('focusin', (event) => {
    if (targetMatches(event, '#variant_select, .bootstrap-select')) {
      startFilterLoop();
    }
  });

  openAndFilter();
})();
